var exports = {
  "p_": "ProfileBadgeSettings.module__list___XzJRa0",
  "AS": "ProfileBadgeSettings.module__item___XzJRa0",
  "nM": "ProfileBadgeSettings.module__row___XzJRa0",
  "xZ": "ProfileBadgeSettings.module__rowLabel___XzJRa0",
  "UI": "ProfileBadgeSettings.module__artSlot___XzJRa0",
  "Qw": "ProfileBadgeSettings.module__art___XzJRa0",
  "pG": "ProfileBadgeSettings.module__caption___XzJRa0",
  "Pf": "ProfileBadgeSettings.module__label___XzJRa0",
  "HI": "ProfileBadgeSettings.module__variants___XzJRa0",
  "N4": "ProfileBadgeSettings.module__note___XzJRa0",
  "h5": "ProfileBadgeSettings.module__status___XzJRa0",
  "pb": "ProfileBadgeSettings.module__filter___XzJRa0",
  "sM": "ProfileBadgeSettings.module__srOnly___XzJRa0",
};

module.exports = exports;
